import {
    ASSET_NAME_BOND,
    ASSET_NAME_STOCK,
    ASSET_NAME_CURRENCY,
    ASSET_NAME_FOND,
    FRAGMENT_ASSET_TYPE,
} from '@alfa-bank/site-invest-emitents-common/constants';

const createSubQuery = (assetType: string, searchStr: string, limit: number) => `
getAssets(
  filter: {
    assetType: {eq: "${assetType}"} 
    searchFilter: {contains: "${searchStr}"}
    currency: {isActive: {eq: true}}
    isVisible: {eq: true}
  }, 
  page: {
    limit: ${limit}, 
    sort: "shortName:asc"
  }) {
    pagination {
        totalCount
    }
    assets {
      id
      name
      ISIN
      ticker
      ${FRAGMENT_ASSET_TYPE}
      issuer {
        id
        name
        shortName
        logo {
          path
        }
      }
    }
}`;

export const createQueryForSearchField = (value: string, limit: number) => `
  query FindAssets {
    ${ASSET_NAME_STOCK}: ${createSubQuery(ASSET_NAME_STOCK, value, limit)}
    ${ASSET_NAME_BOND}: ${createSubQuery(ASSET_NAME_BOND, value, limit)}
    ${ASSET_NAME_CURRENCY}: ${createSubQuery(ASSET_NAME_CURRENCY, value, limit)}
    ${ASSET_NAME_FOND}: ${createSubQuery(ASSET_NAME_FOND, value, limit)}
  }
`;
